import Head from 'next/head';
import { usePathname } from 'next/navigation';
import { FC, ReactNode, useEffect, useState } from 'react';

import { JSONLDInterface } from '@/src/assets/interfaces/jsonLDInterface';
import { baseUrl } from '@/src/assets/utils/baseUrl';

import { IMeta } from '../../assets/interfaces/metaInterface';

type Meta = {
    children: ReactNode;
    meta?: IMeta | null;
    jsonLD?: JSONLDInterface;
};

const Meta: FC<Meta> = ({ children, meta, jsonLD }) => {
    const [href, setHref] = useState('');

    useEffect(() => {
        setHref(window.location.href);
    }, []);

    const path = usePathname();

    return (
        <>
            <Head>
                <title>
                    {meta?.metaTitle || 'High Five Themes – Premium Ghost Themes & Templates'}
                </title>
                <meta
                    name="description"
                    content={
                        meta?.metaDescription ??
                        'High-performance Ghost themes designed for modern publishers, fully responsive and optimized for speed, SEO, and Ghost 5.0+.'
                    }
                />
                <meta
                    property="og:title"
                    content={
                        meta?.ogTitle ??
                        'High Five Themes – Premium Ghost Themes to Captivate Any Audience'
                    }
                />
                <meta
                    property="og:description"
                    content={
                        meta?.ogDescription ??
                        'High-performance, responsive Ghost themes for every publisher, expertly designed for Ghost 5.0+ and the next generation of publishing.'
                    }
                />
                <meta property="og:type" content={meta?.ogType ?? 'website'} />
                <meta property="og:url" content={href} />
                <meta
                    property="og:image"
                    content={
                        meta?.metaImageUrl
                            ? meta.metaImageUrl
                            : baseUrl('/images/deafultMetaImage.jpg')
                    }
                />
                <meta name="twitter:card" content="summary_large_image" />
                <meta
                    name="twitter:image"
                    content={
                        meta?.metaImageUrl
                            ? meta.metaImageUrl
                            : baseUrl('/images/deafultMetaImage.jpg')
                    }
                />
                <meta
                    name="twitter:title"
                    content={
                        meta?.ogTitle ??
                        'High Five Themes – Premium Ghost Themes to Captivate Any Audience'
                    }
                />
                <meta name="twitter:url" content={href} />
                <meta
                    name="twitter:description"
                    content={
                        meta?.ogDescription ??
                        'High-performance, responsive Ghost themes for every publisher, expertly designed for Ghost 5.0+ and the next generation of publishing.'
                    }
                />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.png" />
                <link rel="canonical" href={baseUrl(path.slice(1, -1))} />
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }}
                />
            </Head>
            {children}
        </>
    );
};

export default Meta;
